<template>
  <div class="form-content">
    <div class="form-content-title">
      <div class="form-content-title-block form-title">
        <div class="form-title-block form-title-principal">
          <span>Campañas</span>
        </div>

        <div class="form-title-block">
          <button class="btn btn-primary" @click="openModal('modal-campaign')">
            <i class="fas fa-plus"></i>
            Nuevo codigo
          </button>
        </div>
      </div>
    </div>

    <div class="table-paquete">
      <section class="u-table p-4">
        <div class="u-row u-row--header" style="display: grid;">
          <h4 class="u-row__title">Código</h4>
          <h4 class="u-row__title">Descripción</h4>
          <h4 class="u-row__title">Imagen</h4>
          <h4 class="u-row__title">Monto</h4>
          <h4 class="u-row__title">Cantidad</h4>
          <h4 class="u-row__title">Fecha</h4>
        </div>
        <div v-for="data in codigoCampa" :key="data.id" class="u-row py-3" style="display: grid;"> 
          <p class="p-0 m-0">{{ data.code }}</p>
          <p class="p-0 m-0">
            {{ data.description }}
          </p>
          <img :src="data.img" alt="" width="100" />
          <p class="p-0 m-0">USD {{ data.amount }}</p>
          <p class="p-0 m-0">4</p>
          <p class="p-0 m-0">
            <span class="d-block mb-2">
              <span
                style="opacity: 0.75; font-weight: 600; font-size: 12px"
                class="d-block"
                >Fecha inicio</span
              >
              {{ data.start_date }}
            </span>
            <span class="d-block">
              <span
                style="opacity: 0.75; font-weight: 600; font-size: 12px"
                class="d-block"
                >Fecha expiración</span
              >
              {{ data.end_date }}
            </span>
          </p>
        </div>
      </section>
    </div>
    <!-- Modal nueva campaña -->
    <dialog id="modal-campaign">
      <article class="u-modal">
        <form @submit.prevent="createCode" class="u-modal-content">
          <div class="form-block-text d-flex justify-content-between">
            <span>Agregar nuevo código</span>
            <span style="cursor: pointer" @click="closeModal('modal-campaign')">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                style="fill: rgba(0, 0, 0, 1); transform: ; msfilter: "
              >
                <path
                  d="m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"
                ></path>
              </svg>
            </span>
          </div>
          <div class="form-group">
            <label>Código</label>
            <div class="input-group">
              <input
                v-model="form.code"
                type="text"
                name=""
                class="form-control input"
                required
              />
            </div>
          </div>
          <div class="row">
            <div class="form-group col-6 pl-0">
              <label>Cantidad </label>
              <div class="input-group">
                <input
                  v-model="form.max_amount"
                  type="number"
                  name=""
                  class="form-control input"
                  required
                />
              </div>
            </div>
            <div class="form-group col-6 pr-0">
              <label>Monto </label>
              <div class="input-group">
                <input
                  v-model="form.amount"
                  type="number"
                  name=""
                  class="form-control input"
                  required
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-6 pl-0">
              <label>Fecha inicio</label>
              <div class="input-group">
                <input
                  v-model="form.start_date"
                  type="date"
                  name=""
                  class="form-control input"
                  required
                />
              </div>
            </div>
            <div class="form-group col-6 pl-0">
              <label>Fecha expiración</label>
              <div class="input-group">
                <input
                  v-model="form.end_date"
                  type="date"
                  name=""
                  class="form-control input"
                  required
                />
              </div>
            </div>
          </div>
          <div class="form-group">
            <label>Descripción</label>
            <div class="input-group">
              <textarea
                v-model="form.description"
                type="text"
                name=""
                class="form-control input"
                rows="6"
                required
              ></textarea>
            </div>
          </div>
          <div class="form-group">
            <label>Imagen</label>
            <div class="input-group">
              <input
                type="file"
                @change="handleFileInput"
                name=""
                class="form-control input"
                required
              />
            </div>
          </div>
          <button type="submit" class="btn btn-primary mx-auto d-block mt-4">
            Registrar ingreso
          </button>
        </form>
      </article>
    </dialog>
  </div>
</template>
<script>
import DataTable from "@/components/views/DataTable.vue";
import Pagination from "@/components/views/Pagination.vue";
import axios from "axios";
export default {
  props: ["idUser"],
  components: { DataTable, Pagination },
  created() {
    this.getCodigo();
  },
  data() {
    let sortOrders = {};
    let columns = [
      { label: "N° Orden", name: "id", visible: false },
      { label: "Descripción", name: "product_info", visible: false },
      { label: "Fecha ", name: "fechaCreada", visible: false },
      { label: "Estado", name: "state", visible: false },
      { label: "Monto", name: "total_cost", visible: false },
    ];
    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });
    return {
      codigoCampa: null,
      columns,
      sortKey: "updated_at",
      sortOrders: sortOrders,
      filterKey: "",
      tableData: {
        orderBy: "created_at",
        length: 4,
        page: 1,
      },
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
      },
      is_loading: true,
      form: {
        code: "",
        description: "",
        amount: null,
        active: 1,
        start_date: "",
        end_date: "",
        img: "",
        type: "1",
        max_amount: "",
      },
    };
  },
  methods: {
    handleFileInput(e) {
      const file = e.target.files[0];
      let reader = new FileReader();
      reader.onload = (file) => {
        this.form.img = file.target.result;
      };
      reader.readAsDataURL(file);
    },
    createCode() {
      let url = process.env.API_URL + "/api/campaigns/create/" + this.idUser;

      axios
        .post(url, this.form)
        .then(() => {
          location.reload();
        })
        .catch(() => {
          alert("Error al crear código");
        });
    },
    openModal(id) {
      const modal = document.getElementById(id);
      modal.showModal();
    },
    closeModal(id) {
      const modal = document.getElementById(id);
      modal.close();
    },
    getCodigo() {
      this.is_loading = true;
      //   this.tableData.draw++;
      //   this.tableData.page = page;
      let url = process.env.API_URL + "/api/campaigns/getList/" + this.idUser;

      // eslint-disable-next-line no-unreachable
      axios
        .get(url, { params: this.tableData })
        .then((response) => {
          this.codigoCampa = response.data.body.data;
          this.is_loading = false;
          this.configPagination(response.data.body);
        })
        .catch(() => {
          alert("No se obtuvieron resultados");
          this.is_loading = false;
          return;
        });
    },
    // cleanInput() {
    //   this.tableData.filterValue = "";
    // },
    configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
      this.pagination.perPage = this.tableData.length;
    },
    // sortBy(key) {
    //   this.sortKey = key;
    //   this.sortOrders[key] = this.sortOrders[key] * -1;
    //   this.tableData.orderBy = this.sortOrders;
    //   this.tableData.orderBy = this.getIndex(this.columns, 'name', key)

    //   this.tableData.dir = this.sortOrders[key] === 1 ? "asc" : "desc";

    //   this.getPedidos();
    // },
    // getIndex(array, key, value) {
    //   return array.findIndex((i) => i[key] === value);
    // },
  },
  computed: {
    // filterColumns() {
    //   let activeFilterColumns = ["document_number", "email", "fullname", "cellphone"];
    //   return this.columns.filter((i) => activeFilterColumns.indexOf(i.name) > -1);
    // },
  },
};
</script>



// WEBPACK FOOTER //
// CodigoComponent.vue?0105166a